<template>
  <div class="geo-browser">
    <v-layout row>
      <v-flex sm12 md6 offset-md6>
        <slot/>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm6 md3 v-for="gt in geoTypes" :key="gt.type">
        <v-list subheader>
          <v-subheader>
            Nearby {{ geoTitle(gt) }}
          </v-subheader>
          <v-list-tile ripple v-for="(geo, i) in nearbyGeos[gt.type]" @click="onSelect(geo)" :key="i">
            <v-list-tile-content>
              <v-list-tile-title>{{geo.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-list>
          <v-list-tile ripple @click="onSelect({slug: 'united-states-of-america', name: 'USA'})">
            <v-list-tile-content>
              <v-list-tile-title>United States of America</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import capitalize from 'lodash/capitalize'
  const geoTypes = [{type: 'cities'}, {type: 'counties'}, {type: 'cbsas', name: 'Metros'}, {type: 'states'}]

  export default {
    data: function () {
      return {
        geoTypes: geoTypes
      }
    },
    props: {
      nearbyGeos: {
        type: Object,
        required: true
      },

      onSelect: {
        type: Function,
        required: true
      }
    },
    methods: {
      geoTitle (gt) {
        return capitalize(gt.name ? gt.name : gt.type)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/common/GeoBrowser.vue